<template>
  <div>
    <!-- Versión Escritorio -->
    <template v-if="$vuetify.breakpoint.mdAndUp">
      <v-row>
        <v-col cols="12" style="text-align: end;">
          <v-btn
            rounded
            dark
            outlined
            color="#00a7e4"
            @click="changeComponent"
            style="margin-right: 11px;"
          >
            Cancelar
          </v-btn>

          <v-btn rounded dark class="common-botton" @click="formatInfoComplete">
            Guardar
            <v-icon right>mdi-content-save</v-icon>
          </v-btn>
        </v-col>
      </v-row>

      <commond-form
        :request="data"
        :route="routesConfig.route"
        :run="run"
        :action="routesConfig.action"
        @cancel="run = false"
        @success="changeComponent"
        @afterError="changeComponent"
      >
        <template v-slot:data>
          <v-row>
            <!-- Nombres -->
            <v-col cols="12" sm="6" md="3">
              <v-text-field
                label="Nombre"
                outlined
                v-model="data.nombre"
                color="#00a7e4"
                :rules="requiredRule"
              ></v-text-field>
            </v-col>

            <!-- Apellido paterno -->
            <v-col cols="12" sm="6" md="3">
              <v-text-field
                label="Apellido Paterno"
                outlined
                v-model="data.apellidoPaterno"
                color="#00a7e4"
                :rules="requiredRule"
              ></v-text-field>
            </v-col>

            <!-- Apellido materno -->
            <v-col cols="12" sm="6" md="3">
              <v-text-field
                label="Apellido Materno"
                outlined
                v-model="data.apellidoMaterno"
                color="#00a7e4"
                :rules="requiredRule"
              ></v-text-field>
            </v-col>

            <!-- Fecha nacimiento -->
            <v-col cols="12" sm="6" md="3">
              <v-menu
                v-model="menu2"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="formatFechaNacimiento"
                    label="Fecha de nacimiento"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    outlined
                    color="#00a7e4"
                    :rules="requiredRule"
                  ></v-text-field>
                </template>

                <v-date-picker
                  v-model="data.fechaNacimiento"
                  no-title
                  @input="menu2 = false"
                ></v-date-picker>
              </v-menu>
            </v-col>

            <!-- Género -->
            <v-col cols="12" sm="6" md="3">
              <span class="text-header-data">Género</span>
              <v-radio-group v-model="data.sexo" row :rules="requiredRule">
                <v-radio label="Masculino" :value="1" color="#00a7e4"></v-radio>
                <v-radio label="Femenino" :value="2" color="#00a7e4"></v-radio>
              </v-radio-group>
            </v-col>

            <!-- Celular -->
            <v-col cols="12" sm="6" md="3">
              <v-text-field
                label="Celular"
                outlined
                v-model="data.celular"
                color="#00a7e4"
                :rules="requiredRule"
              ></v-text-field>
            </v-col>

            <!-- RFC -->
            <v-col cols="12" sm="6" md="3">
              <v-text-field
                label="RFC"
                outlined
                v-model="data.rfc"
                color="#00a7e4"
                :rules="rfcRules"
                @input="onInputToUpper"
              ></v-text-field>
            </v-col>

            <!-- Numero colaborador -->
            <v-col cols="12" sm="6" md="3">
              <v-text-field
                label="No. Colaborador"
                outlined
                v-model="data.numero_colaborador"
                color="#00a7e4"
              ></v-text-field>
            </v-col>

            <!-- Correo -->
            <!-- <v-col cols="12" sm="6" md="3">
              <CommonEmailAutocomplete
                :emailEdit="data.correo"
                @emailUpdate="(e) => (data.correo = e)"
              />
            </v-col> -->
          </v-row>
        </template>
      </commond-form>
    </template>

    <!-- Versión Mobile -->
    <template v-else>
      <div class="mobile-container">
        <commond-form
          :request="data"
          :route="routesConfig.route"
          :run="run"
          :action="routesConfig.action"
          @cancel="run = false"
          @success="changeComponent"
          @afterError="changeComponent"
        >
          <template v-slot:data>
            <v-row>
              <!-- Nombre -->
              <v-col cols="12">
                <v-text-field
                  label="Nombre"
                  outlined
                  v-model="data.nombre"
                  color="#00a7e4"
                  :rules="requiredRule"
                ></v-text-field>
              </v-col>

              <!-- Apellidos -->
              <v-col cols="12">
                <v-text-field
                  label="Apellido Paterno"
                  outlined
                  v-model="data.apellidoPaterno"
                  color="#00a7e4"
                  :rules="requiredRule"
                ></v-text-field>
              </v-col>

              <v-col cols="12">
                <v-text-field
                  label="Apellido Materno"
                  outlined
                  v-model="data.apellidoMaterno"
                  color="#00a7e4"
                  :rules="requiredRule"
                ></v-text-field>
              </v-col>

              <!-- Fecha nacimiento -->
              <v-col cols="12">
                <v-menu
                  v-model="menu2"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="formatFechaNacimiento"
                      label="Fecha de nacimiento"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      outlined
                      color="#00a7e4"
                    ></v-text-field>
                  </template>

                  <v-date-picker
                    v-model="data.fechaNacimiento"
                    no-title
                    @input="menu2 = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>

              <!-- Género -->
              <v-col cols="12">
                <v-radio-group v-model="data.sexo" row>
                  <v-radio label="Masculino" :value="1"></v-radio>
                  <v-radio label="Femenino" :value="2"></v-radio>
                </v-radio-group>
              </v-col>

              <!-- Celular -->
              <v-col cols="12">
                <v-text-field
                  label="Celular"
                  outlined
                  v-model="data.celular"
                  color="#00a7e4"
                ></v-text-field>
              </v-col>

              <!-- RFC -->
              <v-col cols="12">
                <v-text-field
                  label="RFC"
                  outlined
                  v-model="data.rfc"
                  color="#00a7e4"
                  :rules="rfcRules"
                  @input="onInputToUpper"
                ></v-text-field>
              </v-col>

              <!-- Numero colaborador -->
              <v-col cols="12">
                <v-text-field
                  label="No. Colaborador"
                  outlined
                  v-model="data.numero_colaborador"
                  color="#00a7e4"
                ></v-text-field>
              </v-col>

              <!-- Correo -->
              <v-col cols="12">
                <CommonEmailAutocomplete
                  :emailEdit="data.correo"
                  @emailUpdate="(e) => (data.correo = e)"
                />
              </v-col>
            </v-row>
          </template>
        </commond-form>

        <div class="mobile-actions">
          <v-btn rounded dark outlined color="#00a7e4" @click="changeComponent">
            Cancelar
          </v-btn>

          <v-btn rounded dark class="common-botton" @click="formatInfoComplete">
            Guardar
            <v-icon right>mdi-content-save</v-icon>
          </v-btn>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import CommondForm from "@/components/commonComponents/CommondForm.vue";
import moment from "moment";
import RfcFacil from "rfc-facil";
import { getAreaNegocio } from "@/services/log/log.service.js";
import { getCuentasCorreoListByParams } from "@/services/cuentasCorreo/cuentasCorreo.service.js";
import CommonEmailAutocomplete from "@/components/commonComponents/CommonEmailAutocomplete.vue";

export default {
  components: {
    CommondForm,
    CommonEmailAutocomplete,
  },
  props: {
    personalData: Object,
    stateList: Array,
    routesConfig: Object,
    listings: Object,
  },
  data() {
    return {
      menu2: false,
      route: "/v1/prospecto/perfil",
      run: false,
      requiredRule: [(v) => !!v || "El campo es requerido"],
      data: {},
      formatFechaNacimiento: "",
      rfcRules: [
        (v) =>
          (v && (v.length === 10 || v.length === 12 || v.length === 13)) ||
          "RFC debe tener 10, 12 o 13 caracteres",
        (v) => !!v || "Campo Requerido",
        (v) =>
          /^[A-Za-z\d]{10,13}$/.test(v) ||
          "RFC no es válido, asegúrate de tener la longitud correcta y utiliza caracteres alfanuméricos",
      ],
      emailRules: [
        (v) => !!v || "El correo es requerido",
        (v) => /.+@.+\..+/.test(v) || "Correo electrónico inválido",
      ],

      rol: JSON.parse(localStorage.getItem("roles"))[0].rol,
      areaNegocioText: "",
      areasNegocio: [],
      cuentasCorreo: [],
      canViewEmails: false,
      areasNegocios: [],
      empresas: [],
    };
  },
  watch: {
    "data.fechaNacimiento"(val) {
      this.formatFechaNacimiento = moment(val, "YYYY-MM-DD").format(
        "DD/MM/YYYY"
      );
      this.actualizarRfc();
    },
    "data.nombre"() {
      this.actualizarRfc();
    },
    "data.apellidoPaterno"() {
      this.actualizarRfc();
    },
    "data.apellidoMaterno"() {
      this.actualizarRfc();
    },
    areasNegocio() {
      this.getAreaNegocio(this.personalData.rol);
    },
    "data.rol"(value) {
      this.getAreaNegocio(value);
    },
  },
  methods: {
    changeComponent() {
      window.location.reload();
      this.$emit("changeComponent", 1);
    },
    actualizarRfc() {
      if (
        !this.data.nombre ||
        !this.data.apellidoPaterno ||
        !this.data.apellidoMaterno ||
        !this.data.fechaNacimiento
      )
        return;
      const arregloNacimiento = this.formatFechaNacimiento
        .split("/")
        .map((e) => Number(e));
      if (arregloNacimiento.length < 3) return;
      const rfc = RfcFacil.forNaturalPerson({
        name: this.data.nombre,
        firstLastName: this.data.apellidoPaterno,
        secondLastName: this.data.apellidoMaterno,
        day: arregloNacimiento[0],
        month: arregloNacimiento[1],
        year: arregloNacimiento[2],
      });
      this.data.rfc = rfc;
    },
    formatInfoComplete() {
      if (
        this.rol == "PROSPECTO" ||
        typeof this.data.idProspecto != "undefined"
      )
        delete this.data.status;

      if (this.routesConfig.completeData) {
        this.data.vigenciaCedula = this.data.vigenciaCedula
          ? moment(this.data.vigenciaCedula, "DD/MM/YYYY").format("YYYY-MM-DD")
          : null;
        this.data.vigenciaPolizaRc = this.data.vigenciaPolizaRc
          ? moment(this.data.vigenciaPolizaRc, "DD/MM/YYYY").format(
              "YYYY-MM-DD"
            )
          : null;
        this.data.fecha_ingreso = this.data.fecha_ingreso
          ? moment(this.data.fecha_ingreso, "DD/MM/YYYY").format(
              "YYYY-MM-DD HH:mm:ss"
            )
          : null;
        this.data.fechaNacimiento = moment(
          this.data.fechaNacimiento,
          "YYYY-MM-DD"
        ).format("YYYY-MM-DD");
        this.run = true;
      } else this.run = true;
    },
    onInputToUpper() {
      this.polizaData.rfc = this.polizaData.rfc.toUpperCase();
    },
    getAreaNegocio(value) {
      const area_negocio_id = this.listings.roles.find((e) => e.id == value)
        ? this.listings.roles.find((e) => e.id == value).area_negocio
        : null;
      if (area_negocio_id) {
        const area_negocio = this.areasNegocio.find(
          (e) => e.id == area_negocio_id
        );
        if (area_negocio) {
          this.areaNegocioText =
            area_negocio.areas +
            " - " +
            area_negocio.departamento +
            " - " +
            area_negocio.proceso;
          this.canViewEmails = area_negocio?.departamento == "POST-VENTA";
        } else
          this.areaNegocioText = "El rol no tiene área de negocio asignado";
      } else this.areaNegocioText = "El rol no tiene área de negocio asignado";
    },
    async getCuentasCorreoListByParams() {
      var body = {
        ...{
          pagina: 1,
          elementosPagina: 100,
        },
      };
      let response = await getCuentasCorreoListByParams(body);
      this.cuentasCorreo = response.cuentas ?? [];
    },
    async getAreaNegocioList() {
      let response = await getAreaNegocio();
      let rol = localStorage.getItem("rolNotAdmin");

      response.map((e) => {
        this.areasNegocios.push({
          id: e.id,
          departamento: e.departamento,
          nombre: `${e.areas} - ${e.departamento} - ${e.proceso}`,
        });
      });
      if (rol.includes("INBOUND"))
        this.areasNegocios = this.areasNegocios.filter(
          (e) => e.departamento == "POST-VENTA"
        );
    },
  },
  async mounted() {
    this.getAreaNegocioList();
    this.getCuentasCorreoListByParams();
    this.areasNegocio = await getAreaNegocio();
    this.getAreaNegocio(this.data.rol);
    this.data = Object.assign({}, this.personalData);
    this.data.sexo = Number(this.data.sexo);
    if (this.rol == "PROSPECTO") delete this.data.idProspecto;
  },
};
</script>

<style>
/* Establece el color del borde a rojo para el campo de texto personalizado */
.my-custom-text-field .v-input--outline {
  border-color: red;
}

/* Cambia el color del texto de la etiqueta flotante (floating label) */
.my-custom-text-field .v-label {
  color: red;
}

@media (max-width: 959px) {
  .mobile-container {
    padding: 16px;
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .mobile-actions {
    margin-top: 16px;
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .mobile-action-button {
    width: 100%;
    max-width: 300px;
    text-align: center;
    font-weight: bold;
  }
}
</style>
